// extracted by mini-css-extract-plugin
module.exports = {"btnSubmit":"style_btnSubmit__2CD41","btnFacebook":"style_btnFacebook__2iOaE","btnGoogle":"style_btnGoogle__28nFU","loginFailure":"style_loginFailure__2GkTD"};